var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { StorageService } from '@/infrastructure/utils/util-services/local-storage/type/local-storage-service.interface';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { SpaceSortType } from '../enums';
import { RouterService } from '@cores/services/vue-router-service';
const LOCAL_STORAGE_SORT_TYPE_KEY = 'LOCAL_STORAGE_SORT_TYPE_KEY';
let SpaceSortTypeServiceImpl = class SpaceSortTypeServiceImpl {
    constructor(_storageService, _routerService) {
        this._storageService = _storageService;
        this._routerService = _routerService;
    }
    getSpaceSortType() {
        const currentRouteName = this._routerService.currentRoute.name;
        if (currentRouteName === 'home') {
            return SpaceSortType.AccessTimeDesc;
        }
        const sortType = this._routerService.currentRoute.query.sort
            || this._storageService.getItem(LOCAL_STORAGE_SORT_TYPE_KEY)
            || SpaceSortType.AccessTimeDesc;
        return sortType;
    }
    setSpaceSortType(sort) {
        this._storageService.setItem(LOCAL_STORAGE_SORT_TYPE_KEY, sort);
    }
};
SpaceSortTypeServiceImpl = __decorate([
    injectable(),
    __param(0, inject(StorageService)),
    __param(1, inject(RouterService)),
    __metadata("design:paramtypes", [typeof (_a = typeof StorageService !== "undefined" && StorageService) === "function" ? _a : Object, typeof (_b = typeof RouterService !== "undefined" && RouterService) === "function" ? _b : Object])
], SpaceSortTypeServiceImpl);
export { SpaceSortTypeServiceImpl };
